<template>
    <div>
        <template>
            <div style="font-size:16px; background-color: #005B5B;">
                <h5 class="text-white text-center"> {{ $t('globalTrans.'+title) }}
                </h5>
            </div>
        </template> <br>
        <b-table-simple bordered responsive>
            <b-tr>
                <b-th>
                    {{ $t('hospital_public_panel.area_type') }} :
                </b-th>
                <b-td>{{ address.area_type_name }}</b-td>
                <b-th>
                    {{$t('hospital_public_panel.division')}} :
                </b-th>
                <b-td>{{address.division_name}}</b-td>
            </b-tr>
            <b-tr>
                <b-th>
                    {{ $t('hospital_public_panel.district') }} :
                </b-th>
                <b-td>{{ address.district_name }}</b-td>
                <b-th v-if="address.area_type_id==1">
                    {{$t('hospital_public_panel.city_corporation')}} :
                </b-th>
                <b-td v-if="address.area_type_id==1">{{address.city_corporation_name}}</b-td>
                <b-th v-if="address.area_type_id==3|| address.area_type_id==2">
                    {{$t('hospital_public_panel.upazila')}} :
                </b-th>
                <b-td v-if="address.area_type_id==3 || address.area_type_id==2">{{address.upazila_name}}</b-td>
            </b-tr>
            <b-tr>
                <b-th v-if="address.area_type_id==2">
                    {{$t('hospital_public_panel.pourashava')}} :
                </b-th>
                <b-td v-if="address.area_type_id==2">{{address.pauroshoba_name}}</b-td>
            </b-tr>
            <b-tr>
                <b-th v-if="address.area_type_id==3">
                    {{$t('hospital_public_panel.union')}} :
                </b-th>
                <b-td v-if="address.area_type_id==3">{{address.union_name}}</b-td>
                <!--  -->
                <b-th>
                    {{$t('org_pro.ward')}} :
                </b-th>
                <b-td>{{address.ward_name}}</b-td>
            </b-tr>
        </b-table-simple>
    </div>
</template>
<script>
import Custom from '../../store/custom'

export default {
    props: ['title', 'data'],
    data () {
        return {
            address: {}
        }
    },
    created () {
        this.address = this.data
        this.manipulateData()
    },
    methods: {
        manipulateData () {
            const areaType = Custom.wardTypeList.find(type => type.id === parseInt(this.address.area_type_id))
            const division = this.$store.state.commonObj.divisionList.find(item => item.value === parseInt(this.address.division_id))
            const district = this.$store.state.commonObj.districtList.find(item => item.value === parseInt(this.address.district_id))
            const city = this.$store.state.commonObj.cityCorporationList.find(item => item.value === parseInt(this.address.city_corporation_id))
            const upazila = this.$store.state.commonObj.upazilaList.find(item => item.value === parseInt(this.address.upazilla_id))
            const pauroshoba = this.$store.state.commonObj.pauroshobaList.find(item => item.value === parseInt(this.address.pauroshoba_id))
            const union = this.$store.state.commonObj.unionList.find(item => item.value === parseInt(this.address.union_id))
            const ward = this.$store.state.commonObj.wardList.find(item => item.value === parseInt(this.address.ward_id))
            let orgData
            if (this.$i18n.locale === 'bn') {
                orgData = {
                    area_type_name: areaType !== undefined ? areaType.name_bn : '',
                    division_name: division !== undefined ? division.text_bn : '',
                    district_name: district !== undefined ? district.text_bn : '',
                    city_corporation_name: city !== undefined ? city.text_bn : '',
                    upazila_name: upazila !== undefined ? upazila.text_bn : '',
                    pauroshoba_name: pauroshoba !== undefined ? pauroshoba.text_bn : '',
                    union_name: union !== undefined ? union.text_bn : '',
                    ward_name: ward !== undefined ? ward.text_bn : ''
                }
            } else {
                orgData = {
                    area_type_name: areaType !== undefined ? areaType.name : '',
                    division_name: division !== undefined ? division.text : '',
                    district_name: district !== undefined ? district.text : '',
                    city_corporation_name: city !== undefined ? city.text : '',
                    upazila_name: upazila !== undefined ? upazila.text : '',
                    pauroshoba_name: pauroshoba !== undefined ? pauroshoba.text : '',
                    union_name: union !== undefined ? union.text : '',
                    ward_name: ward !== undefined ? ward.text : ''
                }
            }
            this.address = Object.assign({}, this.address, orgData)
        }
    }
}
</script>
